import { useState } from 'react';

export const useCommentState = ({ initialValue = '' }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [value, setValue] = useState(initialValue);

  const handleFocusText = () => {
    setOpen(true);
  };

  const handleChange = (_, v) => setValue(v);

  const handleClose = () => {
    setOpen(false);
    setValue(initialValue);
  };

  return {
    field: {
      value: value,
      onChange: handleChange,
      onFocus: handleFocusText,
      error: error,
    },
    dirty: value !== initialValue,
    isValid: () => {
      if (!value) {
        if (!error) {
          setError('Value is required');
        }
        return false;
      } else {
        if (error) {
          setError(null);
        }
        return true;
      }
    },
    open,
    close: handleClose,
    onSetError: setError,
  };
};
